import * as React from 'react';
export const whimsicalSvg = React.forwardRef(function whimsicalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#7B13CF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      opacity: 0.8,
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.053 9.547a.46.46 0 0 0-.651 0l-5.855 5.855a.46.46 0 0 0 0 .651l5.855 5.855c.18.18.47.18.65 0l5.856-5.855a.458.458 0 0 0 0-.65l-5.855-5.856Zm.325-2.277a.919.919 0 0 0-1.3 0l-7.809 7.808a.918.918 0 0 0 0 1.3l7.808 7.808a.919.919 0 0 0 1.301 0l7.807-7.808a.92.92 0 0 0 0-1.301l-7.808-7.808h.001Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.622 7.27a.92.92 0 0 1 1.302 0l7.807 7.808a.918.918 0 0 1 0 1.3l-7.809 7.808a.92.92 0 0 1-1.301 0l-7.806-7.808a.92.92 0 0 1 0-1.301l7.807-7.808Z',
      fill: '#fff',
    }),
  );
});
whimsicalSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var whimsical = {
  category: 'brand',
  colorable: false,
  name: 'whimsical',
  svg: whimsicalSvg,
};
